
    import {computed, ComputedRef, defineComponent, reactive, watch} from 'vue';
    import {useStore} from "@/store";
    import utils from '@/util/index';

    interface State {
        generationDate: string; // 报告出具日期
    }

    export default defineComponent({
        name: "generationDate",
        setup() {
            let state: State = reactive({
                generationDate: '',
            })
            let store = useStore();
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            watch(dataInfo, (data: any) => {
                const {reportDetectOrderVO} = data;
                const {reportGenDate} = reportDetectOrderVO;
                state.generationDate = reportGenDate ? utils.parseDate(reportGenDate) : '';
            })
            return {
                state
            }
        },
        methods: {}
    })
